import React from "react";
import { Redirect, Router, navigate } from "@reach/router";
import HomePage from "./pages/home_page";
import VideoPage from "./pages/video_page";
import NewsPage from "./pages/news_page";
import NewsPageDetail from "./pages/news_detail_page";
import VideoDetailPage from "./pages/video_detail_page";
import PhotoPage from "./pages/photo_page";
import ProfilePage from "./pages/profile_page";
import EventPage from "./pages/event_page";
import EventPromoPage from "./pages/eventpromo_page";
import PodcastPage from "./pages/podcast_page";
import LelangPage from "./pages/lelang_page";
import LelangDetailPage from "./pages/lelang_detail_page";
import PhotoDetail from "./pages/photo_detail";
import PhotoDetailPage2 from "./pages/photo_detail_page_2";
import NotFound from "./pages/404";
import AppTest from "./test/test";
import AccountPage from "./pages/account";
import JoinPage from "./pages/join";
import ReactGA from "react-ga";
import "./css/bootstrap.min.css";
import "./css/main.css";
import "./css/mine.css";
import "./css/add.css";
import { Global } from "./data/page_data";
import CookieTest from "./test/cookie_test";
import EntryPage from "./pages/entry";
import HeaderTest from "./test/header_test";
import LandingPageRoute from "./pages/landing_page/landing_page";
import LandingPageIslami from "./pages/landing_page/landing_page_islami";
import FirstContentPage from "./pages/landing_page/first_content";

ReactGA.initialize("UA-122813796-34");

export const ScrollToTop = ({ children, location }) => {
  React.useEffect(() => window.scrollTo(0, 0), [location.pathname]);
  return children;
};

class App extends React.Component {
  constructor(props) {
    super(props);
    this.reloadInternalPage = this.reloadInternalPage.bind(this);
  }

  componentDidMount() {
    document.addEventListener("click", this.reloadInternalPage, true);
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.reloadInternalPage, true);
  }

  reloadInternalPage(event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return;
    }

    const link = event.target.closest("a");
    if (!link || link.target === "_blank" || link.hasAttribute("download")) {
      return;
    }

    const url = new URL(link.href, window.location.href);
    if (url.origin !== window.location.origin || !url.pathname.startsWith("/w/")) {
      return;
    }

    event.preventDefault();
    window.location.assign(url.href);
  }

  render() {
    return (
      <>
        <Router primary={false} basepath="w/">
          <ScrollToTop path="/">
            <HomePage path=":artist/home" />
            <NewsPage path=":artist/news" />
            <NewsPageDetail path=":artist/news-detail" />
            <VideoPage path=":artist/video" />
            <VideoDetailPage path=":artist/video-detail" />
            <PhotoPage path=":artist/photo" />
            <PhotoDetailPage2 path=":artist/photo-detail" />
            <ProfilePage path=":artist/profile" />

            <EventPage
              path=":artist/event"
              autoplay={true}
              control={false}
              loop={true}
              muted={true}
              playsinline={true}
              preload="auto"
            />

            <EventPromoPage
              path=":artist/eventpromo"
              noback="true"
              control={true}
              gabung={true}
              muted={false}
              loop={false}
              autoplay={true}
              playsinline={true}
            />

            <PodcastPage path=":artist/podcast" />
            <LelangPage path=":artist/lelang" />
            <LelangDetailPage path=":artist/lelang-detail/:id" />
            <AccountPage path=":artist/account" />
            <JoinPage path=":artist/join" />
            <CookieTest path=":artist/read_cookie" />
            <HeaderTest path=":artist/header" />
            <EntryPage path=":artist/entry" />
            <FirstContentPage path={":artist/first"} />
            <LandingPageRoute path={"/lp/*"} />
            <NotFound default />
          </ScrollToTop>
        </Router>
      </>
    );
  }
}

export default App;

/*
TODO
- authenticate
- fix back
- fix lelang status
- lelang bid
- fix videolist other tan from detail use link
- notify bulet merah
- account lelang klik
- lelang detail klik
- lelang home iamge klik
- lelang detail
*/
